/**
 *  Failed Customer Interactions Standard (FCI)
 *  https://confluence.ancestry.int/pages/viewpage.action?spaceKey=AA&title=Failed+Customer+Interactions+Standard
 */

export enum FciErrorType {
	// AJAX Failure (Major Error)
	// Errors on AJAX data requests that result in full pages/screens, panes, or tabs that contain no content
	emptyContent,

	// Action initiated by AJAX could not be completed (Major Error)
	// Errors on essential AJAX POST, PUT, or DELETE requests. Ex.: Unable to update or delete data
	action,

	// Non-functional convenience feature (Minor Errors)
	// Non working convenience features such as typeahead, hover, form validation
	convenience,

	// Substitution of alternate information (Minor Errors)
	// Substitution of fallback data not likely to be noticed by a user
	// Default avatar vs profile image, Substitute handle for full name, Generic thumbnail image
	transparentSubstitution
}

export class FciErrorTypeHelper {
	static enumToString(errorType: FciErrorType | undefined) {
		switch (errorType) {
			case FciErrorType.emptyContent:
				return 'Empty Content';
			case FciErrorType.action:
				return 'Action';
			case FciErrorType.convenience:
				return 'Convenience';
			case FciErrorType.transparentSubstitution:
				return 'Transparent Substitution';
		}
		return null;
	}

	static stringToEnum(errorType: string) {
		switch (errorType) {
			case 'Empty Content':
				return FciErrorType.emptyContent;
			case 'Action':
				return FciErrorType.action;
			case 'Convenience':
				return FciErrorType.convenience;
			case 'Transparent Substitution':
				return FciErrorType.transparentSubstitution;
		}
		return null;
	}
}
